import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import { Dashboard as DashboardIcon, BarChart as BarChartIcon, History as HistoryIcon } from "@mui/icons-material";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { t } from "@lingui/core/macro";

export function mainListItems(navigate) {
    return (
        <React.Fragment>
            <ListItemButton
                key="Dashboard"
                aria-label={t`Dashboard`}
                onClick={() => navigate('/dashboard')}
            >
                <ListItemIcon>
                    <DashboardIcon/>
                </ListItemIcon>
                <ListItemText primary={t`Dashboard`}/>
            </ListItemButton>
            <ListItemButton
                key="Reports"
                aria-label={t`Reports`}
                onClick={() => navigate('/dashboard/reports')}
            >
                <ListItemIcon>
                    <BarChartIcon/>
                </ListItemIcon>
                <ListItemText primary={t`Reports`}/>
            </ListItemButton>
            <ListItemButton
                key="History"
                aria-label={t`History`}
                onClick={() => navigate('/dashboard/history')}
            >
                <ListItemIcon>
                    <HistoryIcon/>
                </ListItemIcon>
                <ListItemText primary={t`History`}/>
            </ListItemButton>
        </React.Fragment>
    );
}
